import { isMobileDevice } from '@/util/getDeviceType'
import store from '@/store/index'

// Sync with IB
export default {
  data() {
    return {
      zendeskUrl: "https://static.zdassets.com/ekr/snippet.js?key=cc87f973-cf2c-4796-9682-21ec29cee2d4",
      zendeskUrlCn: "https://static.zdassets.com/ekr/snippet.js?key=68392d2b-3c9b-430d-b432-8a413bba100d",
      zendeskUrlIran: "https://static.zdassets.com/ekr/snippet.js?key=c93671ec-879f-4ea6-9087-0aebc748d505",
      isMobile: false,
    }
  },
  computed: {
    lang() {
      return store.state.common.lang
    },
  },
  mounted() {
    window.addEventListener('resize', this.checkDeviceType)
    this.setZendeskStyleSnippet()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkDeviceType)
    this.removeZendeskStyleSnippet()
    this.removeZendeskSnippet()
  },
  watch: {
    isMobile() {
      this.setZendeskStyleSnippet()
    },
    lang: {
      immediate: true,
      handler() {
        if (this.lang === 'zh_CN' || this.lang === 'zh_TW') {
          this.addZendeskSnippet(this.zendeskUrlCn)
        }  else if (this.lang === 'fa') {
          this.addZendeskSnippet(this.zendeskUrlIran)
        }  else {
          this.addZendeskSnippet(this.zendeskUrl)
        }
      },
    }
  },
  methods: {
    checkDeviceType() {
      this.isMobile = isMobileDevice()
    },
    setZendeskStyleSnippet() {
      this.removeZendeskStyleSnippet()
      this.zendeskStyleSnippet = document.createElement('style')
      this.zendeskStyleSnippet.setAttribute('type', 'text/css')

      this.zendeskStyleSnippet.innerHTML = `
        @media (max-height: 700px) {
          div[style*="visibility: visible"]:not(:has(iframe[style*="position: fixed"][style*="width: 100%"][style*="height: 100%"])) {
            position: fixed;
            right: 0;
            bottom: 0;
            z-index: 999999;
            transform: scale(0.7) !important;
            transform-origin: right top !important;
          }
        }

        @media (max-width: 600px) {
          div[style*="visibility: visible"]:not(:has(iframe[style*="position: fixed"][style*="width: 100%"][style*="height: 100%"])) {
            position: fixed;
            right: 0;
            bottom: 0;
            z-index: 999999;
            transform: scale(0.7) !important;
            transform-origin: right top !important;
          }
        }
      `

      if (!this.isMobile) {
        this.zendeskStyleSnippet.innerHTML += `
          /* max-height: none when chatbox icon hidden */
          div[style*="visibility: visible"] iframe[title][name][style*="width: 380px"][style*="max-height: none"] {
            max-height: calc(100vh - 32px) !important;
          }

          @media (min-width: 768px) {
            div[style*="visibility: visible"] iframe[title][name][style*="width: 380px"][style*="max-height: calc(100vh - 104px)"] {
              width: 750px !important;
              max-height: calc(100vh - 104px) !important;
            }
          }
        `
      }

      document.head.appendChild(this.zendeskStyleSnippet)
    },
    removeZendeskStyleSnippet() {
      if (this.zendeskStyleSnippet) {
        this.zendeskStyleSnippet?.parentNode?.removeChild(this.zendeskStyleSnippet)
      }
    },
    async addZendeskSnippet(url) {
      await  this.removeZendeskSnippet()
      await new Promise((resolve, reject) => {
        this.zendeskSnippet = document.createElement('script')
        this.zendeskSnippet.id = 'ze-snippet'
        this.zendeskSnippet.src = url
        this.zendeskSnippet.async = true

        this.zendeskSnippet.onload = () => {
          if (window.zE) {
            window.zE('messenger:set', 'locale', this.$options.filters.zendeskLangSwitch(this.lang))
            // Widget is loaded, resolve the promise
            resolve(window.zE)
          } else {
            reject('Zendesk widget failed to load.')
          }
        }
        this.zendeskSnippet.onerror = () => reject('Zendesk script load error.')
        document.body.appendChild(this.zendeskSnippet)
      })
    },
    removeZendeskSnippet() {
      return new Promise((resolve, reject) => {
        console.log('开始卸载 Zendesk 脚本')
        try {
          window.zE = undefined
          window.zEmbed = undefined
          window.zEACLoaded = undefined
          window.zESettings = undefined
//          zE('messenger:set', 'locale', this.$options.filters.zendeskLangSwitch(val));

          const launcher = document.querySelector('#launcher')
          if (launcher) {
            console.log('移除 launcher')
            launcher.parentElement.parentElement.remove()
          }

          // 移除 web_widget iframe
          const webWidgetIframe = document.querySelector(
            'iframe[data-product="web_widget"]',
          )
          if (webWidgetIframe) {
            console.log('移除 web_widget iframe')
            webWidgetIframe.remove()
          }

          // 重置加载状态
          this.isZendeskLoaded = false
          // 移除现有的 zendesk 脚本
          const existingScript = document.getElementById('ze-snippet')
          if (existingScript) {
            console.log('移除 Zendesk 脚本')
            existingScript.remove()
          }

          console.log('Zendesk 脚本卸载完成')
          const time = setTimeout(() => {
            resolve(true)
            clearTimeout(time)
          }, 100)
        } catch (error) {
          console.error('卸载 Zendesk 脚本时发生错误:', error)
          reject(error)
        }
      })
    },
  },
}
